import type {
  SelectionList,
  SelectionListIdNames,
  ValidValueTypes,
} from '@revelio/iso-utility';

import type { SpecificCustomSkill } from '../../../../../../shared/selection-lists/hooks/useSpecificCustomSkills';
import { skillLevelToListName } from './custom-skills.helpers';

export const buildReportsCustomSkillSelectionLists = (
  data: SpecificCustomSkill[]
): SelectionList<ValidValueTypes>[] => {
  if (data.length === 0) {
    return [];
  }

  return data.map((levelData, index) => {
    const listId = skillLevelToListName(levelData);
    const previousLevelData = data[index - 1];
    const parentListIdRaw = previousLevelData
      ? skillLevelToListName(previousLevelData)
      : undefined;

    const value = levelData.refs.map((ref) => {
      const parents = Array.isArray(ref.parents) ? ref.parents : [];
      const parentIndex = index - 1;
      const parentIdValue = parentIndex >= 0 ? parents[parentIndex] : undefined;

      return {
        id: String(ref.id),
        shortName: ref.short_name,
        longName: ref.long_name,
        ...(parentListIdRaw && parentIdValue != null
          ? { [parentListIdRaw]: String(parentIdValue) }
          : {}),
        ...(Array.isArray(ref.titles) && ref.titles.length
          ? { rawTitles: ref.titles }
          : {}),
      };
    });

    return {
      id: listId,
      label: levelData.label.label as unknown as SelectionListIdNames,
      value,
    } as SelectionList<ValidValueTypes>;
  });
};
